import './ClOfferList.css';

import React from 'react';
import classname from '@search/classname/src';

const cn = classname.bind(null, 'ClOfferList');

export function ClOfferList({ children }: {
    children: React.ReactNode;
}) {
    return (
        <div className={cn()}>
            {children}
        </div>
    );
}
